import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const ITEMS_PER_PAGE = 6;

const Suggection = () => {
  const orders = useSelector((state) => state.orders.list);
  const [currentPage, setCurrentPage] = useState(1);
  const [, forceUpdate] = useState(0); // 👈 re-render trigger

  // 🔁 Auto refresh ONLY this component every 5 sec
  useEffect(() => {
    const interval = setInterval(() => {
      forceUpdate(v => v + 1);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  if (orders.length === 0) {
    return (
      <div className="p-6 text-center text-gray-500 text-xl">
        No products available.
      </div>
    );
  }

  // pagination calc
  const totalPages = Math.ceil(orders.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentOrders = orders.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE
  );

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Suggested Products</h2>

      {/* Table */}
      <div className="overflow-x-auto bg-white shadow-md rounded-xl border">
        <table className="w-full text-sm text-left">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="p-3">Image</th>
              <th className="p-3">Product</th>
              <th className="p-3">Product ID</th>
              <th className="p-3">Amount</th>
              <th className="p-3">Qty</th>
              <th className="p-3">Status</th>
              <th className="p-3">Date</th>
            </tr>
          </thead>

          <tbody>
            {currentOrders.map((order) => (
              <tr key={order.id} className="border-t hover:bg-gray-50">
                <td className="p-3">
                  <img
                    src={order.thumbnail || "https://via.placeholder.com/80"}
                    alt={order.item}
                    className="w-16 h-12 object-cover rounded border"
                  />
                </td>

                <td className="p-3 font-medium">{order.item}</td>
                <td className="p-3">{order.id}</td>
                <td className="p-3">{order.amount}</td>
                <td className="p-3">{order.qty}</td>

                <td className="p-3">
                  <span
                    className={`px-2 py-1 rounded-full text-xs font-semibold
                      ${
                        order.status === "Pending"
                          ? "bg-yellow-100 text-yellow-700"
                          : order.status === "Processing"
                          ? "bg-blue-100 text-blue-700"
                          : order.status === "Delivered"
                          ? "bg-green-100 text-green-700"
                          : "bg-gray-100 text-gray-600"
                      }
                    `}
                  >
                    {order.status}
                  </span>
                </td>

                <td className="p-3 text-xs text-gray-500">
                  {order.date} <br /> {order.time}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex justify-center items-center gap-2 mt-6">
        <button
          onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
          disabled={currentPage === 1}
          className="px-4 py-2 border rounded-lg disabled:opacity-40"
        >
          Prev
        </button>

        {[...Array(totalPages)].map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrentPage(i + 1)}
            className={`px-4 py-2 rounded-lg border ${
              currentPage === i + 1
                ? "bg-black text-white"
                : "bg-white"
            }`}
          >
            {i + 1}
          </button>
        ))}

        <button
          onClick={() =>
            setCurrentPage((p) => Math.min(p + 1, totalPages))
          }
          disabled={currentPage === totalPages}
          className="px-4 py-2 border rounded-lg disabled:opacity-40"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Suggection;
